// Static content for B. Thornton Capital & Asset Group

export const PHONE = "(301) 895-2950";
export const PHONE_HREF = "tel:+13018952950";
export const EMAIL = "Info@bthorntoncapitalgroup.com";
export const EMAIL_HREF = "mailto:Info@bthorntoncapitalgroup.com";
export const WEBSITE = "BThorntoncapitalgroup.com";
export const WEBSITE_HREF = "https://bthorntoncapitalgroup.com";
export const LOGO = "/emblem.png";
export const TAGLINE_IMG = "/tagline.png";

export const IMAGES = {
  heroBg:
    "https://images.unsplash.com/photo-1646333915428-de1c2a92faf3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cityNight:
    "https://images.unsplash.com/photo-1648726443128-6b031ce955fb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  about:
    "/about-working.jpg?v=3",
  realEstate:
    "https://images.unsplash.com/photo-1765766601592-ac2936aa87e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  ctaBg:
    "https://images.unsplash.com/photo-1565043534426-8a67ac8671e2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV = [
  { id: "about", label: "About" },
  { id: "services", label: "Services" },
  { id: "package", label: "Launch Package" },
  { id: "why", label: "Why Us" },
  { id: "process", label: "Process" },
  { id: "contact", label: "Contact" },
];

export const SERVICES = [
  {
    id: "asset-recovery",
    index: "01",
    title: "Asset Recovery Services",
    headline: "Recover What's Rightfully Yours",
    intro:
      "Millions of dollars in surplus funds and unclaimed assets remain undiscovered every year. We help locate and recover what belongs to you.",
    items: [
      "Foreclosure Surplus Funds",
      "Tax Sale Overages",
      "Unclaimed Property",
      "Probate Assets",
      "Escrow Refunds",
      "Financial Asset Investigations",
      "Government-Held Funds",
      "Other Recoverable Assets",
    ],
    note: "No Upfront Fees. You Pay Only When We Successfully Recover Your Funds.",
  },
  {
    id: "real-estate",
    index: "02",
    title: "Real Estate Acquisitions",
    headline: "Creating Opportunities Through Real Estate",
    price: "$699",
    purchase: {
      total: "$699",
      fullKey: "real_estate_acquisitions",
      installmentKey: "real_estate_acquisitions_x2",
      installmentAmount: "$349.50",
      installment3Key: "real_estate_acquisitions_x3",
      installment3Amount: "$233.00",
    },
    intro:
      "Whether you're a first-time investor or a seasoned buyer, we help you identify and secure profitable real estate opportunities — and teach you the strategies to build lasting wealth.",
    items: [
      "Wholesale Real Estate",
      "Off-Market Properties",
      "Distressed Property Acquisitions",
      "Investment Property Consulting",
      "Cash Buyer Opportunities",
      "Property Research",
      "Transaction Coordination",
      "Tax Lien & Tax Deed Property Acquisition",
      "Owner-Builder Strategy — Eliminate High Builder Costs",
      "Rehab-to-Rental Acquisition Guidance",
    ],
    note: null,
  },
  {
    id: "personal-credit",
    index: "03",
    title: "Credit Elevation Blueprint",
    headline: "Build Better Credit. Build a Better Future.",
    price: "$799",
    purchase: {
      total: "$799",
      fullKey: "credit_elevation_blueprint",
      installmentKey: "credit_elevation_blueprint_x2",
      installmentAmount: "$399.50",
      installment3Key: "credit_elevation_blueprint_x3",
      installment3Amount: "$266.33",
    },
    intro:
      "Our credit consulting services help clients understand and improve their personal credit profiles through compliant, educational, and strategic guidance.",
    items: [
      "Credit Analysis",
      "Credit Restoration Assistance",
      "Collection Review",
      "Charge-Off Review",
      "Credit Education",
      "Credit Monitoring Guidance",
      "Credit Score Improvement Strategies",
    ],
    note: null,
  },
  {
    id: "business-credit",
    index: "04",
    title: "Business Credit Solutions",
    headline: "Separate Your Business From Your Personal Credit",
    intro:
      "Strong business credit opens doors to higher funding limits, better financing options, and long-term growth opportunities.",
    items: [
      "Business Credit Consulting",
      "Business Credit Profile Setup",
      "Vendor Tradeline Guidance",
      "Funding Readiness Consulting",
      "Business Credit Education",
      "Credit Monitoring Recommendations",
    ],
    note: null,
  },
  {
    id: "web-brand",
    index: "05",
    title: "The Digital Presence Suite",
    headline: "Your Brand. Your Website. Beautifully Done.",
    price: "$699",
    purchase: {
      total: "$699",
      fullKey: "digital_presence_suite",
      installmentKey: "digital_presence_suite_x2",
      installmentAmount: "$349.50",
      installment3Key: "digital_presence_suite_x3",
      installment3Amount: "$233.00",
    },
    intro:
      "A complete done-for-you digital identity — a custom logo and a polished professional website that make your business look established from day one.",
    items: [
      "Custom Professional Logo Design",
      "Professional Website (Up to Five Pages)",
      "Mobile-Responsive Build",
      "Domain & Hosting Setup Guidance",
      "Business Email Setup",
      "Contact & Lead-Capture Forms",
      "SEO-Ready Foundation",
      "Brand Color & Font Kit",
    ],
    note: null,
  },
];

export const PACKAGE = {
  price: "$1,199",
  purchase: {
    total: "$1,199",
    fullKey: "entrepreneur_launch_package",
    installmentKey: "entrepreneur_launch_package_x2",
    installmentAmount: "$599.50",
    installment3Key: "entrepreneur_launch_package_x3",
    installment3Amount: "$399.67",
  },
  name: "The Entrepreneur Launch Package",
  tagline: "Everything You Need to Launch Your Business Professionally.",
  includes: [
    "Business Name Consultation",
    "EIN Registration",
    "D-U-N-S® Number Registration",
    "Professional Business Email",
    "Dedicated Business Phone Number",
    "Custom Professional Logo",
    "Professional Landing Page",
    "Business Credit Setup Consultation",
    "Business Credit Starter Guide",
    "SBA Business Plan & Proposal Assistance",
    "30-Minute Business Strategy Session",
  ],
  perfectFor: [
    "New Entrepreneurs",
    "Startups",
    "Existing Businesses Ready To Scale",
    "Side Hustles Becoming Full-Time Businesses",
  ],
};

export const WHY = [
  {
    title: "Professional",
    desc: "Committed to excellence and ethical business practices.",
  },
  {
    title: "Experienced",
    desc: "Providing strategic financial and business consulting solutions.",
  },
  {
    title: "Confidential",
    desc: "Your information remains private and secure.",
  },
  {
    title: "Results Focused",
    desc: "Every recommendation is designed with your success in mind.",
  },
  {
    title: "Nationwide Service",
    desc: "Helping clients across the United States.",
  },
];

export const STEPS = [
  {
    step: "Step 1",
    title: "Schedule Your Consultation",
    desc: "Tell us about your goals, challenges, and vision.",
  },
  {
    step: "Step 2",
    title: "Develop Your Strategy",
    desc: "We'll create a customized action plan based on your specific needs.",
  },
  {
    step: "Step 3",
    title: "Execute & Grow",
    desc: "Our team works alongside you to help achieve measurable financial and business success.",
  },
];

export const SERVE = [
  "Entrepreneurs",
  "Small Business Owners",
  "Investors",
  "Real Estate Professionals",
  "Independent Contractors",
  "Startups",
  "Families",
  "Working Professionals",
  "Nonprofit Organizations",
];

export const TESTIMONIALS = [
  {
    name: "C. Justice",
    location: "Baltimore, MD",
    quote:
      "I couldn't believe the results, my personal credit score jumped over 125 points in just 30 days! B. Thornton Capital & Asset Group knew exactly what steps to take, and their expertise made it happen.",
  },
  {
    name: "H. West",
    location: "Philadelphia, PA",
    quote:
      "B. Thornton Capital & Asset Group helped me build my business credit from the ground up, and I finally have a professional website to match. Their knowledge of credit building and business development set them apart.",
  },
  {
    name: "M. Ford",
    location: "Baltimore, MD",
    quote:
      "The Entrepreneurs package was a game changer, from setting up my LLC, to securing my D&B number, to launching my company website. B. Thornton Capital & Asset Group guided me through every step with real expertise.",
  },
  {
    name: "D. Johnson",
    location: "Baltimore, MD",
    quote:
      "I can't even put into words how much I appreciate you for guiding me towards the land of success! Thanks to your help and advice, I'm booming with my personal credit, my credit cards are on point, and my business credit is rising month after month, and I'm thriving with wholesaling real estate. You changed the game for me, and I'll be grateful to you for that forever!",
  },
  {
    name: "Q. Allen",
    location: "Jacksonville, FL",
    quote:
      "Beyond business, he taught me how to save over 60% on a new house purchase, simply by purchasing the land myself and hiring an independent contractor instead of going through a builder and paying retail. He genuinely checks every box needed to set you up for success, that's Big Bro for life!",
  },
];

export const SERVICE_OPTIONS = [
  "Asset Recovery Services",
  "Real Estate Acquisitions",
  "Personal Credit Solutions",
  "Business Credit Solutions",
  "The Entrepreneur Launch Package",
  "General Inquiry",
];

